export default __webpack_public_path__ + "static/media/location.10090d33.svg";